
class Login extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.recoveryForm = this.element.querySelector("#ForgotPass");
    this.loginForm = this.element.querySelector("#logIn");
   

    if (window.location.href.indexOf("recover") != -1) {
      console.log('recover');
      this.openRecover();
    }

    this.bindEvents();
  }

  bindEvents() {
    this.delegateElement.on(
      "click",
      '[data-action="toggle-recovery"]',
      this.openRecover.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="toggle-login"]',
      this.openLogin.bind(this)
    );

  }
  openRecover() {
    if (event){
      event.preventDefault();
    }

    this.recoveryForm.setAttribute('aria-hidden', 'false');
    this.loginForm.setAttribute('aria-hidden', 'true');
  

  }
  openLogin() {
    if (event){
      event.preventDefault();
    }

    this.recoveryForm.setAttribute('aria-hidden', 'true');
    this.loginForm.setAttribute('aria-hidden', 'false');

  }

}
customElements.define("customer-login", Login);


class AccountComponent extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);

    new Popup(this.element);

    this.accountHeader = this.element.querySelector('.customerAccount--Header');

   this.addNewBtn = this.element.querySelector('.customer-add-address-btn');
   if(this.addNewBtn)
    this.addNewBtn.style.display = 'none';

    if(responsive.matchesBreakpoint('pocket')){
    this.carouselElement = this.element.querySelector('.swiper');
    this.carousel = new RevolutionSwiper(this.carouselElement);
    }
    
    this.bindEvents();
    this.handleRefreshState();

  }
  bindEvents() {
    this.delegateElement.on('click', '[data-action="toggle-subtab"]', this.toggleSubTab.bind(this));
    this.delegateElement.on('click', '[data-action="toggle-tab"]', this.toggleTab.bind(this));
    
    this.delegateElement.on(
      "click",
      '[data-action="delete-address"]',
      this.deleteAddress.bind(this)
    );

  }

  handleRefreshState() {
   /*  if (responsive.matchesBreakpoint('lap_and_up')) { */
      this.element.querySelector('#contactInfo').setAttribute('aria-visible', 'true');
 
    // Get the URL search parameters
    var searchParams = new URLSearchParams(window.location.search);

    // Get the value of param1
    var param1Value = searchParams.get('location');

    // Check if param1 has a value
    if (param1Value) {
      this.toggleTab(false, param1Value);
    }
  }

  deleteAddress(event) {
    const id = event.target.getAttribute("data-id");

  
    Shopify.postLink("/account/addresses/" + id, {
      parameters: { _method: "delete" },
    });

  }

  toggleTab(event, paramValue) {
    let id = paramValue;
    if (event) {
      id = event.target.dataset.id;
    }

    const allTabs = this.element.querySelectorAll('.customerAccount--MenuTab[aria-expanded="true"]');
    const allContent = this.element.querySelectorAll('.customerAccount--Content');
  
    if(this.addNewBtn){
        if(id === 'contactAddresses'){
          this.addNewBtn.style.display = 'flex';
        }else{
          this.addNewBtn.style.display = 'none';
        }
    }

    allTabs.forEach((tab) => {
      tab.setAttribute('aria-expanded', 'false');
    });
    if (event) {
      if(event.target.id == 'button--toggle-addresses') {
        this.element.querySelector('[data-id=contactAddresses]').setAttribute('aria-expanded', 'true');
      } else {
        event.target.setAttribute('aria-expanded', 'true');
      }  
    } else {
      this.element.querySelector(`[data-id="${id}"]`).setAttribute('aria-expanded', 'true');
    }


    allContent.forEach((content) => {
      if (!content.classList.contains('customerAccount--ContentOrders')) {
        content.setAttribute('aria-visible', 'false');
      }

    });

    const content = this.element.querySelector(`#${id}`);

   
    if (content) {
      content.setAttribute('aria-visible', 'true');
    }

    // Get the current URL
    var currentUrl = window.location.href;

    // Create a new URL with updated search parameters
    var newUrl = currentUrl.split('?')[0] + `?location=${id}`;

    // Modify the URL without refreshing the page
    window.history.pushState({ path: newUrl }, '', newUrl);

  }


  toggleSubTab(event) {

    const id = event.target.dataset.id;
    const allTabs = this.element.querySelectorAll('.customerAccount--toggleTab[aria-expanded="true"]');
    const allContent = this.element.querySelectorAll('.customerAccount--ContentOrders');



    allTabs.forEach((tab) => {
      tab.setAttribute('aria-expanded', 'false');
    });

    event.target.setAttribute('aria-expanded', 'true');

    allContent.forEach((content) => {
      content.setAttribute('aria-visible', 'false');
    });

    const content = this.element.querySelector(`#${id}`);
    if (content) {
      content.setAttribute('aria-visible', 'true');
    }
  }
}


customElements.define("account-component-inner", AccountComponent);